import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Building2 } from "lucide-react";

const STATUS_STYLES = { prospective: "badge-submitted", active: "badge-approved", past: "badge-neutral", inactive: "badge-nosend" };

export default function Clients() {
  const [clients, setClients] = useState(null);
  const [filter, setFilter] = useState("");

  useEffect(() => { api.get("/admin/clients").then((r) => setClients(r.data)); }, []);

  if (!clients) return <div className="text-sm text-[#78716C] animate-pulse" data-testid="clients-loading">Loading clients…</div>;
  const shown = clients.filter((c) => !filter || c.client_status === filter);

  return (
    <div className="space-y-6" data-testid="clients-page">
      <div className="fade-up">
        <p className="eyebrow">Admin only</p>
        <h1 className="section-title text-3xl mt-1">Client Database</h1>
        <p className="mt-3 text-sm text-[#57534E] max-w-2xl">
          Prospective and current clients, contacts, and engagement documents — the same records used by
          Service Operations, so information stays consistent. Internal notes and procurement documents are Admin-only.
        </p>
      </div>
      <div className="flex flex-wrap gap-2 fade-up-1" data-testid="client-status-filters">
        {["", "prospective", "active", "past", "inactive"].map((s) => (
          <button key={s || "all"} onClick={() => setFilter(s)} data-testid={`client-filter-${s || "all"}`}
            className={`rounded-full px-4 py-1.5 text-xs font-bold border ${filter === s ? "bg-navy text-white border-navy" : "bg-white border-[#E7E1D4]"}`}>
            {s ? s[0].toUpperCase() + s.slice(1) : "All"}</button>
        ))}
      </div>
      <div className="grid sm:grid-cols-2 gap-4 fade-up-2">
        {shown.map((c) => (
          <Link key={c.id} to={`/clients/${c.id}`} className="card card-hover p-5 block" data-testid={`client-card-${c.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-sand flex items-center justify-center text-terracotta"><Building2 size={18} /></div>
                <div>
                  <div className="font-serif font-bold text-navy">{c.name}</div>
                  {c.is_sample && <span className="badge-neutral mt-0.5 inline-block">Sample</span>}
                </div>
              </div>
              <span className={STATUS_STYLES[c.client_status] || "badge-neutral"} data-testid={`client-status-${c.id}`}>{c.client_status}</span>
            </div>
            <div className="flex flex-wrap gap-x-5 gap-y-1 mt-4 text-xs text-[#78716C]">
              <span><b className="text-navy">{c.school_count}</b> schools</span>
              <span><b className="text-navy">{c.contact_count}</b> contacts</span>
              <span><b className="text-navy">{c.engagement_count}</b> engagements</span>
              <span><b className="text-navy">{c.proposal_count}</b> proposals</span>
              <span><b className="text-navy">{c.document_count}</b> documents</span>
            </div>
          </Link>
        ))}
        {shown.length === 0 && <p className="text-sm text-[#78716C]" data-testid="clients-empty">No clients in this status.</p>}
      </div>
    </div>
  );
}
